module.exports = __webpack_public_path__ + "img/LMS Aset Ilustration Empty Group.e8719e76.png";